import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";

import { ModalContainer, LoadingIcon } from "./styledComponents";

function LoadingModal(props) {
  return (
    <ModalContainer
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={true}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={true}>
        <LoadingIcon
          style={{ height: "80px", width: "80px", color: "#FDB51B" }}
        />
      </Fade>
    </ModalContainer>
  );
}
//color:"#FDB51B"
export default LoadingModal;
